import type { GroupDto, GroupWithMemberCountDto } from "../../services/UserService";
import type { Group, GroupWithMemberCount } from "../../state/group";
import GroupId from "../../state/GroupId";
import { toGrant, toGrantDto } from "./grant";

export const toGroup = (dto: GroupDto): Group => ({
  id: GroupId.from(dto.id),
  name: dto.name,
  grants: dto.grants.map(toGrant),
  externallyManaged: dto.externallyManaged,
});

export const toGroupWithMemberCount = (dto: GroupWithMemberCountDto): GroupWithMemberCount => ({
  ...toGroup(dto),
  memberCount: dto.memberCount,
});

export const toGroupDto = (group: Group): GroupDto => ({
  id: group.id.toString(),
  name: group.name,
  grants: group.grants.map(toGrantDto),
  externallyManaged: group.externallyManaged,
});
